<template>
    <section class="endpoint-section endpoint-errors">
        <header>
            <h4 class="endpoint-section-title">Possible errors</h4>
        </header>
        <dl v-if="hasErrors" class="endpoint-error-list">
            <template v-for="(reasons, statusCode) in errors">
                <dt :key="statusCode" class="endpoint-error-code">{{ statusCode }}</dt>
                <dd v-for="(reason, index) in reasons" :key="statusCode + index" class="endpoint-error-reason">
                    <markdown>{{ reason }}</markdown>
                </dd>
            </template>
        </dl>
        <span v-else class="data-missing">This endpoint has no expected error conditions</span>
    </section>
</template>

<script>
  import Markdown from 'vue-markdown-v2';

  export default {
    name: 'EndpointErrors',

    components: {
      Markdown,
    },

    props: {
      errors: {
        type:     [ Object, Array ],
        required: true,
      },
    },

    data () {
      return {};
    },

    computed: {
      hasErrors () {
        return Object.keys(this.errors).length > 0;
      },
    },
  };
</script>

<style scoped>
    .endpoint-section-title {
        margin: 0 0 1rem;
    }

    .endpoint-error-list {
        display:   flex;
        flex-wrap: wrap;
        margin:    0;
    }

    .endpoint-error-code,
    .endpoint-error-reason {
        padding: 0.25rem 0.5rem;
    }

    .endpoint-error-code {
        flex:        0 0 4rem;
        font-weight: bold;
        font-size:   1.25rem;
        font-family: var(--font-family-monospace);
        color:       var(--color-red);
        text-shadow: 1px 1px rgba(255, 255, 255, 0.5);
    }

    .endpoint-error-reason {
        flex:        1 0 calc(100% - 4rem);
        margin:      0;
        border-left: 1px solid var(--color-gray-light);
    }

    .endpoint-error-reason + .endpoint-error-reason {
        flex:        0 0 100%;
        margin-left: 4rem;
    }

    .endpoint-error-reason + .endpoint-error-code,
    .endpoint-error-reason + .endpoint-error-code + .endpoint-error-reason {
        border-top: 1px solid var(--color-gray-light);
    }

    .endpoint-error-reason >>> p {
        margin: 0;
    }

    .data-missing {
        color: var(--color-gray-medium);
    }
</style>
